import { render, staticRenderFns } from "./email-invitation.vue?vue&type=template&id=e725b086&scoped=true&lang=pug"
import script from "./email-invitation.vue?vue&type=script&lang=js"
export * from "./email-invitation.vue?vue&type=script&lang=js"
import style0 from "./email-invitation.vue?vue&type=style&index=0&id=e725b086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e725b086",
  null
  
)

export default component.exports